<template>

    <p class="webdesc webdesc_hui">若您对网站有任何意见或者建议，请发邮件至 service@holylightbbs.com Copyright © 2025 圣光检索</p>



</template>

<script>


export default {
    data() {
        return{



        }
    },
    methods: {



    },created() {

     }
};
</script>

<style scoped>






    .iconsa{
        position: absolute;
        top: 40%;
        width: 100%;
        margin:250px 0 0 0px;

        overflow: hidden;



        box-sizing: border-box;


    }
.iconsa_row{

    background: rgba(0, 0, 0, 0.3);
    padding: 10px 10px;



}
    .saitem{
        cursor: pointer;
    }
     .saitem .left{width: 50%;text-align: right;float: left;}
     .saitem .right{width: 50%;line-height: 50px;float: right;}
    .saitem .left img{width: 50px;height: 50px;}
    .saitem .right span{color: #f3f3f3;font-size: 10px;margin-left: 5px;}





</style>
